import * as actions from '../redux/actions';

import {
	ThemeFiveContactForm,
	ThemeFiveIconsSection,
	ThemeFiveSearchBox,
	ThemeFiveSlider,
	ThemeFiveTitles,
} from '..';

import CommonSearchBox from '../common/search-box/CommonSearchBox';
import HeroSection from '../common/HeroSection/HeroSection';
import HomeBanners from '../HomeBanners';
import React from 'react';
import ZoomSlider from '../common/ZoomSlider/ZoomSlider';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../functions/getIcons/getIcons';
import getSlides from '../functions/getSlides/getSlides';

const Theme5 = props => {
	const { history, operator } = props;
	return (
		<div className="theme-five">
			<div style={{ position: 'relative' }}>
				{operator && operator.operator_name === "jeldres" ?
					(
						<HeroSection height={'78vh'} heroImage={getIcons('Banner', operator)} />
					) : (<HomeBanners
						slides={getSlides('Banner', operator)}
						// height={'80vh'}
						activeDotColor={operator && operator.color_codes && operator.color_codes.tertiary_color}
					/>)
				}
				<div className="searchboxoverlay">
					{/* <ThemeFiveSearchBox history={history} operator={operator} /> */}
					<CommonSearchBox history={history} operator={operator} />
				</div>
			</div>

			<div style={{ marginTop: 40 }}>
				<ThemeFiveIconsSection />
			</div>

			<ThemeFiveTitles smallHeading="Conoce" boldHeading="NUESTROS DESTINOS" />

			<ThemeFiveSlider slides={getSlides('Destination', operator)} />

			{operator && operator.operator_name !== 'centraltour' && (
				<div className="contact-home-banner">
					<img src={getIcons('ContactBg', operator)} alt="" />
				</div>
			)}

			{operator && operator.operator_name !== 'centraltour' && (
				<div className="contact-home-form">
					<ThemeFiveContactForm actions={props.actions} />
				</div>
			)}

			{operator && operator.operator_name === 'trrass' && (
				<div style={{ marginTop: 30, marginBottom: 30 }}>
					<ThemeFiveTitles
						smallHeading="Queremos dar las gracias a"
						boldHeading="NUESTROS ALIADOS BUSÓLOGOS"
					/>

					<ThemeFiveSlider slides={getSlides('Busologists', operator)} />
				</div>
			)}
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	// return {
	//   actions: bindActionCreators({ ...actions }, dispatch),
	// };
}

export default connect(mapStateToProps, mapDispatchToProps)(Theme5);



// WEBPACK FOOTER //
// ./src/features/themes/theme5/Theme5.js